import { immer } from 'zustand/middleware/immer';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export interface FeedItem {
    isMarket: boolean;
    trader: string;
    buy: boolean;
    pair: number;
    openPrice: number;
    positionSize: number;
    leverage: number;
    createdAt: string;
}

interface FeedState {
    feed: FeedItem[];
    pending: FeedItem[];
    atTop: boolean;
    showNewButton: boolean;
    setAtTop: (val: boolean) => void;
    addNewFeed: (items: FeedItem[]) => void;
    mergePending: () => void;
    clear: () => void;
}

export const useFeedStore = createWithEqualityFn<FeedState>()(
    immer((set, get) => ({
        feed: [],
        pending: [],
        atTop: true,
        showNewButton: false,

        setAtTop: (val) => {
            set((state) => {
                state.atTop = val;
            });
        },

        addNewFeed: (items) => {
            const { feed, atTop, pending } = get();

            if (!feed.length) {
                set((state) => {
                    state.feed.unshift(...items);
                });

                return;
            }

            const latestTime = pending.length
                ? new Date(pending[0].createdAt).getTime()
                : new Date(feed[0].createdAt).getTime();

            // Lọc ra các phần tử mới hơn
            const newItems = items
                .slice(0, 20)
                .filter(
                    (item) => new Date(item.createdAt).getTime() > latestTime
                );

            if (!newItems.length) {
                return;
            }

            set((state) => {
                if (atTop) {
                    state.feed.unshift(...newItems);
                    if (state.feed.length > 500) state.feed.length = 500;
                } else {
                    state.pending.unshift(...newItems);
                    state.showNewButton = true;
                }
            });
        },

        mergePending: () => {
            set((state) => {
                if (state.pending.length > 0) {
                    state.feed.unshift(...state.pending);
                    if (state.feed.length > 500) state.feed.length = 500;
                    state.pending = [];
                    state.showNewButton = false;
                }
            });
        },

        clear: () => {
            set((state) => {
                state.feed = [];
                state.pending = [];
                state.atTop = true;
                state.showNewButton = false;
            });
        },
    })),
    shallow
);
